export const W4_CURRENT_FORM_YEAR = 2026;

export type W4CoordinatesSign = {
  x: number;
  y: number;
  height: number;
  opacity: number;
};

export type W4CoordinatesDate = {
  x: number;
  y: number;
  size: number;
  color?: { red: number; green: number; blue: number };
};

export type W4FieldIndices = {
  employerName: number;
  date: number;
  ein: number;
  step3Total?: number;
  getAmountFormIndex?: (amountIndex: number) => number;
};

export type W4FormVersionConfig = {
  pdfUrl: string;
  coordinatesSign: W4CoordinatesSign;
  coordinatesDate: W4CoordinatesDate;
  useFormFields: boolean;
  fieldIndices?: W4FieldIndices;
  fieldMaxLengths?: Record<number, number>;
};

const W4_FORM_VERSIONS: Record<number, W4FormVersionConfig> = {
  2023: {
    pdfUrl: 'https://arb-systems-s3-public.s3.us-east-2.amazonaws.com/public/Employment-Eligibility/fw4.pdf',
    coordinatesSign: {
      x: 100,
      y: 150,
      height: 40,
      opacity: 1,
    },
    coordinatesDate: {
      x: 460,
      y: 167,
      size: 12,
      color: undefined,
    },
    useFormFields: true,
  },
  2026: {
    pdfUrl: 'https://arb-systems-s3-public.s3.us-east-2.amazonaws.com/public/Employment-Eligibility/fw4-2026.pdf',
    coordinatesSign: {
      x: 100,
      y: 80,
      height: 40,
      opacity: 1,
    },
    coordinatesDate: {
      x: 460,
      y: 92,
      size: 12,
      color: undefined,
    },
    useFormFields: true,
    fieldIndices: {
      employerName: 16,
      date: 17,
      ein: 18,
      step3Total: 11,
      getAmountFormIndex: (amountIndex: number) => {
        if (amountIndex <= 14) return amountIndex;
        if (amountIndex >= 18 && amountIndex <= 46) return amountIndex + 1;
        return amountIndex;
      },
    },
    fieldMaxLengths: {
      18: 10,
    },
  },
};

export function getW4FormConfig(year: number): W4FormVersionConfig {
  const config = W4_FORM_VERSIONS[year];
  if (config) return config;
  return W4_FORM_VERSIONS[2023];
}

export function getCurrentW4Config(): W4FormVersionConfig {
  return getW4FormConfig(W4_CURRENT_FORM_YEAR);
}
